function FormField({ field, value, onChange }) {
  const id = `field-${field.name}`;
  const baseInputClass = 'w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm';

  const handleChange = (e) => {
    const val = field.type === 'checkbox' ? e.target.checked : e.target.value;
    onChange(field.name, val);
  };

  const renderInput = () => {
    switch (field.type) {
      case 'textarea':
        return (
          <textarea
            id={id}
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder || ''}
            rows={field.rows || 4}
            required={field.required}
            className={baseInputClass}
          />
        );

      case 'select':
        return (
          <select
            id={id}
            value={value || ''}
            onChange={handleChange}
            required={field.required}
            className={baseInputClass}
          >
            <option value="">Select...</option>
            {(field.options || []).map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        );

      case 'checkbox':
        return (
          <div className="flex items-center">
            <input
              id={id}
              type="checkbox"
              checked={!!value}
              onChange={handleChange}
              className="h-4 w-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
            />
            <label htmlFor={id} className="ml-2 text-sm text-gray-700">
              {field.checkboxLabel || field.label}
            </label>
          </div>
        );

      case 'date':
        return (
          <input
            id={id}
            type="date"
            value={value || ''}
            onChange={handleChange}
            required={field.required}
            className={baseInputClass}
          />
        );

      case 'number':
        return (
          <input
            id={id}
            type="number"
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder || ''}
            min={field.min}
            max={field.max}
            required={field.required}
            className={baseInputClass}
          />
        );

      case 'email':
        return (
          <input
            id={id}
            type="email"
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder || ''}
            required={field.required}
            className={baseInputClass}
          />
        );

      case 'text':
      default:
        return (
          <input
            id={id}
            type="text"
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder || ''}
            required={field.required}
            className={baseInputClass}
          />
        );
    }
  };

  return (
    <div className="mb-4">
      {field.type !== 'checkbox' && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
          {field.label}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {field.helpText && (
        <p className="text-xs text-gray-500 mb-1">{field.helpText}</p>
      )}
      {renderInput()}
    </div>
  );
}

export default FormField;
